import { render, staticRenderFns } from "./PackageEditor.vue?vue&type=template&id=05a76018&scoped=true&"
import script from "./PackageEditor.vue?vue&type=script&lang=js&"
export * from "./PackageEditor.vue?vue&type=script&lang=js&"
import style0 from "./PackageEditor.vue?vue&type=style&index=0&id=05a76018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a76018",
  null
  
)

export default component.exports